import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@savvy-kit/components/dropdown-menu';
import IconButton from '@savvy-kit/components/icon-button';
import { MoreHorizontalIcon } from 'lucide-react';

import type { EllipsisCellContentProps } from '../../types/cell-types';

export function EllipsisCellContent<TData>({
  items,
  row,
  variant = 'ghost',
  size = 'sm',
  className,
}: EllipsisCellContentProps<TData>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger render={<IconButton variant={variant} size={size} className={className} />}>
        <MoreHorizontalIcon className="size-4" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {items.map((item) => (
          <DropdownMenuItem
            key={item.value}
            onClick={() => item.onClick?.(row)}
            variant={item.variant}
            disabled={item.disabled}
          >
            {item.icon}
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
